import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../components/Login.vue'
import Splesh from "@/views/Splesh.vue";
import payView from "@/views/PayView.vue";
import QrSacner from "@/components/QrSacner.vue";
import ProgramView from "@/views/ProgramView.vue";
import SansView from "@/views/SansView.vue";
import logout from "@/components/Logout.vue";
import UserSales from "@/views/userSales.vue";

const routes = [
    {
        path: '/',
        name: 'splwsh',
        component: Splesh
    },
    {
        path: '/home',
        name: 'home',
        component: HomeView
    },
    {
        path: '/scaner',
        name: 'scaner',
        component: QrSacner
    },
    {
        path: '/program',
        name: 'program',
        component: ProgramView
    },
    {
        path: '/userSales',
        name: 'user-sales',
        component: UserSales
    },
    {
        path: '/sans/:program_id',
        name: 'sans',
        component: SansView
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/logout',
        name: 'logout',
        component: logout
    },
    {
        path: `/pay/:name`,
        name: 'pay-view',
        component: payView
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
